import { useRouter } from 'next/router'
import { Button } from '@mc/design-system'
import { useTranslation } from '@mc/i18n'
import { paths } from '@mc/paths'
import { NavigationEvents } from '@mc/track-event'
import { trackHowItWorksCTAClick } from './utils'

interface HowItWorksCtaProps {
  textCTAKey: string
  className?: string
}

export const HowItWorksCta = ({
  textCTAKey,
  className = '',
}: HowItWorksCtaProps) => {
  const { t } = useTranslation('@mc/next')
  const router = useRouter()
  const { pathname, query } = router

  const handleClick = () => {
    trackHowItWorksCTAClick({
      action: t(textCTAKey),
      level: NavigationEvents.LEVELS.PRIMARY,
      pathname,
      query,
    })()
  }

  return (
    <Button
      as='a'
      href={paths.enterpriseHowItWorks}
      kind='link'
      className={`mc-text--bold ${className}`}
      symmetrical
      onClick={handleClick}
    >
      {t(textCTAKey)}
    </Button>
  )
}
